import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const SIDE = 'https://images.unsplash.com/photo-1457369804613-52c61a468e7d?auto=format&fit=crop&w=1200&q=80';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const reason = params.get('reason');
  const next = params.get('next') || '/inbox';
  const [email, setEmail] = useState('ravi@rivet.aero');
  const [password, setPassword] = useState('rivet-dev-2026');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await login(email, password);
      nav(next);
    } catch (e) {
      // If the account exists but isn't verified, resume the verification flow
      // instead of dead-ending. The backend has already re-sent a fresh code.
      if (e.code === 'EMAIL_UNVERIFIED' || e.data?.error?.fieldErrors?.pendingVerification) {
        const verifyEmail = e.data?.error?.fieldErrors?.email || email;
        nav(`/verify?email=${encodeURIComponent(verifyEmail)}`);
        return;
      }
      setErr(e.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-split">
      <div className="auth-left">
        <div className="auth-card">
          <div className="auth-brand">
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'inherit', textDecoration: 'none' }}>
              <img src="/cnerzy-logo.png" alt="cnerzy" className="brand-logo" />
              <span>Rivet</span>
            </Link>
          </div>
          <h1>Sign in</h1>
          <p className="muted">Welcome back. Pick up where you left off.</p>
          {reason === 'expired' && (
            <div className="banner review">
              Your session expired — please sign in again.
            </div>
          )}
          <form onSubmit={onSubmit}>
            <label className="field">
              <span className="label">Email</span>
              <input className="input" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
            </label>
            <label className="field">
              <span className="label">Password</span>
              <input type="password" className="input" value={password} onChange={(e) => setPassword(e.target.value)} />
            </label>
            {err && <div className="banner risk">{err}</div>}
            <button className="btn" disabled={busy} style={{ width: '100%' }}>{busy ? 'Signing in…' : 'Sign in'}</button>
          </form>
          <div className="auth-footer">
            New to Rivet? <Link to="/signup">Start free</Link> · <Link to="/forgot" style={{ color: 'var(--accent)' }}>Forgot password?</Link>
          </div>
        </div>
      </div>
      <div className="auth-right" style={{ backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.72), rgba(0,0,0,0.45)), url(${SIDE})` }}>
        <div className="auth-right-inner">
          <div className="kicker light">Aerospace Standard Parts · RFQ Intelligence</div>
          <h2>Structured. Quality-aware. Audit-ready.</h2>
        </div>
      </div>
    </div>
  );
}
